import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlanService from "../../services/plan.service";

/* =================== Thunks =================== */

export const getPlan = createAsyncThunk(
  "plan/getPlan",
  async (params, thunkAPI) => {
    try {
      const response = await PlanService.getPlan(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addPlan = createAsyncThunk(
  "plan/addPlan",
  async (data, thunkAPI) => {
    try {
      const response = await PlanService.addPlan(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const assignPlan = createAsyncThunk(
  "plan/assignPlan",
  async (data, thunkAPI) => {
    try {
      const response = await PlanService.assignPlan(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatePlan = createAsyncThunk(
  "plan/updatePlan",
  async (payload, thunkAPI) => {
    try {
      const response = await PlanService.editPlan(payload);
      console.log(response.data)
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const deletePlan = createAsyncThunk(
  "plan/deletePlan",
  async (id, thunkAPI) => {
    try {
      await PlanService.deletePlan(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



const initialState = {
  loading: false,
  error: null,
  planlist: [],
  updateSuccess: false,
};



const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.planlist = action.payload?.data || [];
      })
      .addCase(getPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPlan.fulfilled, (state, action) => {
        state.loading = false;

        const newPlan =
          action.payload?.data ||
          action.payload?.planData ||
          action.payload;

        if (newPlan) {
          state.planlist.unshift(newPlan);
        }
      })
      .addCase(addPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updatePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updatePlan.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.planData;

        if (updated?._id && Array.isArray(state.planlist)) {
          const index = state.planlist.findIndex(
            (item) => item._id === updated._id
          );

          if (index !== -1) {
            state.planlist[index] = updated;
          }
        }
      })
      .addCase(updatePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deletePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePlan.fulfilled, (state, action) => {
        state.loading = false;
        state.planlist = state.planlist.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deletePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = planSlice.actions;
export default planSlice.reducer;
